export default "__VITE_ASSET__CSmefA$4__"